import React, {useRef, useState} from 'react';
import { Content } from './styles';
import DatePicker, { registerLocale}  from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAuth } from '../../hooks/Auth';
import toast from 'react-hot-toast';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import {api} from '../../services/api';
import { Simbol, Selo, RegraDia} from '../Simbols/styles';
import CardAssinatura from '../CardAssinatura';

registerLocale('ptBR', ptBR);

interface iDataForms{
  data?: any;
  setShowmodal?: any;
  setUpdateciclo?: any;
  setUpdateTotalCiclos?: any;
}


export const AddDia: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {

  const { user } = useAuth();

  const [sensacao, setSensacao] = useState(1);
  const [dia, setDia] = useState(data.diaini ? new Date(data.diaini) : new Date());
  const [id_user] = useState(parseInt(data.id_user));
  const [iduseredit] = useState(parseInt(user.iduser));
  const [obssensacao, setObs] = useState('');
  const [inifimciclo] = useState(data.inifimciclo? parseInt(data.inifimciclo) : null);
  const [numciclo] = useState(parseFloat(data.numciclo));
	const [addpadrao, setAddPadrao] = useState(1);
  const textarea = useRef(null);


  async function handleAddDia(){
    const diaStr = format(dia, "yyy-MM-dd");
    const send = {
      id_user,
      'dia' : diaStr,
      sensacao,
      obssensacao,
      iduseredit,
      inifimciclo,
      numciclo,
      addpadrao
    }
    //console.log(send)
    try {
      await api.post('/ciclos/addDia.php', send);
      toast.success('ANOTAÇÃO ADICIONADA COM SUCESSO');
      if(inifimciclo === 1){
        setTimeout(function(){
          window.location.reload();
      }, 500)
        
      } else {
        setUpdateciclo(true);
      }
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ADICIONAR';
      toast.error(resp);
    }

  }
  return (
      <Content>
        <DatePicker
          dateFormat="dd/MM/yyyy"
          locale="ptBR" 
          selected={dia} 
          onChange={(date: Date) => setDia(date)} 
          className="datepick"
          maxDate={new Date()}
          disabled={data.diafim ? true : false}
          excludeDates={data.excludedates}
        />
        <fieldset>
          <legend>Sensação na Vulva:</legend>
          <div className="grid4">
              <button className={`${sensacao === 1 && 'checked'}`} onClick={() => setSensacao(1)}>MOLHADA SANGUE</button>
              <button className={`${sensacao === 3 && 'checked'}`} onClick={() => setSensacao(3)}>ÚMIDA BORRA</button>
              <button className={`${sensacao === 4 && 'checked'}`} onClick={() => setSensacao(4)}>ÚMIDA</button>
              <button className={`${sensacao === 5 && 'checked'}`} onClick={() => setSensacao(5)}>SECA</button>
              <button className={`${sensacao === 2 && 'checked'}`} onClick={() => setSensacao(2)}>MOLHADA</button>
              <button className={`${sensacao === 6 && 'checked'}`} onClick={() => setSensacao(6)}>PEGAJOSA</button>
              <button className={`${sensacao === 7 && 'checked'}`} onClick={() => setSensacao(7)}>ESCORREGADIA</button>
          </div>
        </fieldset>

        <div>
          <textarea ref={textarea} onChange={(textarea) => setObs(textarea.currentTarget.value)} value={obssensacao} maxLength={150} placeholder="Informe o que você vê, e ou uma observação."></textarea>
        </div>

        <div className="flex">
            <div className="flex">
            <input type="checkbox" id="addpadrao" name="addpadrao" value={addpadrao} onClick={() => setAddPadrao(addpadrao === 1 ? 0 : 1)} defaultChecked />
            <small> add padrão da regra</small>
            </div>
            <button className="add" onClick={handleAddDia}>adicionar</button>
        </div>
      </Content>
  );
}

export const Edit: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {

  const { user } = useAuth();

  const [sensacao, setSensacao] = useState(parseInt(data.sensacao));
  const [id_user] = useState(parseInt(data.id_user));
  const [iduseredit] = useState(parseInt(user.iduser));
  const [obssensacao, setObs] = useState(data.obssensacao);
  const [numciclo] = useState(parseFloat(data.numciclo));
  const textarea = useRef(null);


  async function handleChangeDia(){
    
    const send = {
      "id_mob": parseFloat(data.id_mob),
      id_user,
      'dia' : data.dia,
      sensacao,
      obssensacao,
      iduseredit,
      'inifimciclo': data.inifimciclo,
      numciclo,
      "regra": parseFloat(data.regra),
      "fertilidade": parseFloat(data.fertilidade),
      "selo": parseFloat(data.selo),
      "relacao": parseFloat(data.relacao),
      "regradia": parseFloat(data.regradia)
    }
    //console.log(send)
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
  }

  async function handleDelDia(){    
    const send = {
      "id_mob": parseFloat(data.id_mob),
      id_user,
      iduseredit
    }
    
    try {
      await api.post('/ciclos/delDia.php', send);
      toast.success('ANOTAÇÃO DELETADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR APAGAR';
      toast.error(resp);
    }

  }

  function confirmDel(){
    confirmAlert({
      title: 'Confirme',
      message: 'Tem certeza que deseja pagar? esta ação não poderá ser desfeita.',
      buttons: [
        {
          label: 'SIM',
          onClick: () => handleDelDia()
        },
        {
          label: 'Não',
          onClick: () => {}
        }
      ]
    });
  }

  return (
      <Content>
        <fieldset>
          <legend>Sensação na Vulva:</legend>
          <div className="grid4">
              <button className={`${sensacao === 1 && 'checked'}`} onClick={() => setSensacao(1)}>MOLHADA SANGUE</button>
              <button className={`${sensacao === 3 && 'checked'}`} onClick={() => setSensacao(3)}>ÚMIDA BORRA</button>
              <button className={`${sensacao === 4 && 'checked'}`} onClick={() => setSensacao(4)}>ÚMIDA</button>
              <button className={`${sensacao === 5 && 'checked'}`} onClick={() => setSensacao(5)}>SECA</button>
              <button className={`${sensacao === 2 && 'checked'}`} onClick={() => setSensacao(2)}>MOLHADA</button>
              <button className={`${sensacao === 6 && 'checked'}`} onClick={() => setSensacao(6)}>PEGAJOSA</button>
              <button className={`${sensacao === 7 && 'checked'}`} onClick={() => setSensacao(7)}>ESCORREGADIA</button>
          </div>
        </fieldset>

        <div>
            <textarea ref={textarea} onChange={(textarea) => setObs(textarea.currentTarget.value)} value={obssensacao} maxLength={150} placeholder="Se desejar digite uma observação"></textarea>
        </div>

        <div className="flex">
            <button className="del" onClick={confirmDel}>Deletar</button>
            <button className="add" onClick={handleChangeDia}>atualizar</button>
        </div>
      </Content>
  );
}

export const EditSimb: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {
  const { user } = useAuth();
  const [regra, setRegra] = useState(parseFloat(data.regra));

  async function handleChangeDia(e:number){ 
    setRegra(e);  
    const send = {
      "id_mob": parseFloat(data.id_mob),
      "id_user": parseInt(data.id_user),
      "dia" : data.dia,
      "sensacao": parseInt(data.sensacao),
      "obssensacao": data.obssensacao,
      "iduseredit": parseInt(user.iduser),
      "inifimciclo": data.inifimciclo,
      "numciclo": parseFloat(data.numciclo),
      "regra": e,
      "fertilidade": parseFloat(data.fertilidade),
      "selo": parseFloat(data.selo),
      "relacao": parseFloat(data.relacao),
      "regradia": parseFloat(data.regradia)  
    }
    
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
  }



  return (
      <Content>        
        <div className="grid3">
            <button className={`${regra === 1 && 'checked'}`} onClick={() => handleChangeDia(1)}><Simbol><div className={"regra1"}></div></Simbol></button>
            <button className={`${regra === 2 && 'checked'}`} onClick={() => handleChangeDia(2)}><Simbol><div className={"regra2"}></div></Simbol></button>
            <button className={`${regra === 3 && 'checked'}`} onClick={() => handleChangeDia(3)}><Simbol><div className={"regra3"}></div></Simbol></button>
            <button className={`${regra === 4 && 'checked'}`} onClick={() => handleChangeDia(4)}><Simbol><div className={"regra4"}></div></Simbol></button>
            <button className={`${regra === 5 && 'checked'}`} onClick={() => handleChangeDia(5)}><Simbol><div className={"regra5"}></div></Simbol></button>
            <button className={`${regra === 6 && 'checked'}`} onClick={() => handleChangeDia(6)}><Simbol><div className={"regra6"}></div></Simbol></button>
            <button className={`${regra === 7 && 'checked'}`} onClick={() => handleChangeDia(7)}><Simbol><div className={"regra7"}></div></Simbol></button>
            <button className={`${regra === 8 && 'checked'}`} onClick={() => handleChangeDia(8)}><Simbol><div className={"regra8"}></div></Simbol></button>
            <button className={`${regra === 9 && 'checked'}`} onClick={() => handleChangeDia(9)}><Simbol><div className={"regra9"}></div></Simbol></button>
        </div>
      </Content>
  );
}

export const EditSelo: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {

  
  const { user } = useAuth();
  const [selo, setSelo] = useState(parseFloat(data.selo));

  async function handleChangeDia(e:number){ 
    setSelo(e);  
    const send = {
      "id_mob": parseFloat(data.id_mob),
      "id_user": parseInt(data.id_user),
      "dia" : data.dia,
      "sensacao": parseInt(data.sensacao),
      "obssensacao": data.obssensacao,
      "iduseredit": parseInt(user.iduser),
      "inifimciclo": data.inifimciclo,
      "numciclo": parseFloat(data.numciclo),
      "regra": parseFloat(data.regra),
      "fertilidade": parseFloat(data.fertilidade),
      "selo": e,
      "relacao": parseFloat(data.relacao),
      "regradia": parseFloat(data.regradia)  
    }
    //console.log(send)
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
  }



  return (
      <Content>        
        <div className="grid4auto">
            <button className={`${selo === 1 && 'checked'}`} onClick={() => handleChangeDia(1)}><Selo><div className={"regra1"}></div></Selo></button>
            <button className={`${selo === 2 && 'checked'}`} onClick={() => handleChangeDia(2)}><Selo><div className={"regra2"}></div></Selo></button>
            <button className={`${selo === 3 && 'checked'}`} onClick={() => handleChangeDia(3)}><Selo><div className={"regra3"}></div></Selo></button>
            <button className={`${selo === 4 && 'checked'}`} onClick={() => handleChangeDia(4)}><Selo><div className={"regra4"}></div></Selo></button>
        </div>
      </Content>
  );
}

export const ChangePositionCiclo: React.FC<iDataForms> = ({ data }) => {

  
  const { user } = useAuth();
  const [selectciclos, setSelectciclos] = useState(data.numciclo);
  
  async function handleChangePositionCiclo(){ 

    const send = {      
      "id_user": parseInt(data.id_user),
      "iduseredit": parseInt(user.iduser),      
      "numciclo": parseFloat(data.numciclo),
      "selectciclos" : selectciclos
    }
  
    //console.log(send)
    try {
      await api.post('/ciclos/chageCicloPosition.php', send);
      toast.success('SUCESSO, AGUARDE');
      setTimeout(function(){
        window.location.reload();
      }, 700);
      
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
    
  }

  return (
      <Content>  
        <div className="grid4auto">
        {data.allciclos.map((e:any, i:number) => (
          i === 0 ? (
            <button key={i} className={`${selectciclos === e.numciclo && 'checked'}`} onClick={() => setSelectciclos(e.numciclo)}>Ciclo Atual</button>  
          ) : (
            <button key={i} className={`${selectciclos === e.numciclo && 'checked'}`} onClick={() => setSelectciclos(e.numciclo)}>{data.allciclos.length - i}º Ciclo</button>
          )
        ))}        
        </div>    
        <div className="flex">
            <div></div>
            <button className="add" onClick={() => handleChangePositionCiclo()}>Mudar posição</button>
        </div>
        
      </Content>
  );
}

export const Assine: React.FC<iDataForms> = () => {
  
  return (
    <CardAssinatura />
  );
}

export const AddRegra: React.FC<iDataForms> = ({ data, setShowmodal }) => {

  const { user } = useAuth();

  const [iduser] = useState(parseInt(data.id_user));
  const [iduseredit] = useState(parseInt(user.iduser));
  const [instrucao, setInstrucao] = useState('');  
  const textarea = useRef(null);


  async function handleAddregra(){
    const send = {
      iduser,
      iduseredit,
      instrucao,
      lido: 0
    }
    //console.log(send)
    try {
      await api.post('/regras/addRegra.php', send);
      toast.success('REGRA ADICIONADA COM SUCESSO');
      setShowmodal(false);

      setTimeout(function(){
          window.location.reload();
      }, 500);
       
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ADICIONAR';
      toast.error(resp);
    }

  }
  return (
      <Content>
        
        <div>
            <textarea ref={textarea} onChange={(textarea) => setInstrucao(textarea.currentTarget.value)} value={instrucao} maxLength={500} rows={5} placeholder="Digite a mensagem, aviso e novas instruções ao usuário"></textarea>
        </div>

        <div className="flex">
            <span></span>            
            <button className="add" onClick={handleAddregra}>adicionar</button>
        </div>
      </Content>
  );
}

export const EditRegra: React.FC<iDataForms> = ({ data, setShowmodal }) => {

  const { user } = useAuth();
  // console.log(data)
  const [iduser] = useState(parseInt(data.dados.iduser));
  const [idregra] = useState(parseInt(data.dados.idregra));
  const [iduseredit] = useState(parseInt(user.iduser));
  const [instrucao, setInstrucao] = useState(data.dados.instrucao);  
  const textarea = useRef(null);


  async function handleEditregra(){
    const send = {
      iduser,
      idregra,
      iduseredit,
      instrucao
    }
    //console.log(send)
    try {
      await api.post('/regras/editRegra.php', send);
      toast.success('REGRA MODIFICADA COM SUCESSO');
      setShowmodal(false);

      setTimeout(function(){
          window.location.reload();
      }, 500);
       
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR MODIFICAR';
      toast.error(resp);
    }

  }
  return (
      <Content>
        
        <div>
            <textarea ref={textarea} onChange={(textarea) => setInstrucao(textarea.currentTarget.value)} value={instrucao} maxLength={500} rows={5} placeholder="Digite a mensagem, aviso e novas instruções ao usuário"></textarea>
        </div>

        <div className="flex">
            <span></span>            
            <button className="add" onClick={handleEditregra}>SALVAR</button>
        </div>
      </Content>
  );
}

export const EditSimbCor: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {
  const { user } = useAuth();
  const [regra, setRegra] = useState(parseFloat(data.regra));
  const [selo, setSelo] = useState(parseFloat(data.selo));
  
  async function handleChangeDia(){ 
    
    const send = {
      "id_mob": parseFloat(data.id_mob),
      "id_user": parseInt(data.id_user),
      "dia" : data.dia,
      "sensacao": parseInt(data.sensacao),
      "obssensacao": data.obssensacao,
      "iduseredit": parseInt(user.iduser),
      "inifimciclo": data.inifimciclo,
      "numciclo": parseFloat(data.numciclo),
      "regra": regra > 0 ? regra : 0,
      "fertilidade": parseFloat(data.fertilidade),
      "selo": selo,
      "relacao": parseFloat(data.relacao),
      "regradia": parseFloat(data.regradia)  
    }
    //console.log('send', send);
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
  }

  

  function handleChangeBoth(){
    let r = regra > 0 ? regra : 0;
    let s = selo > 0 ? selo : 0;
    if(r === 0 && s === 0){
      toast.error('ESCOLHA PELO MENOS 1 SÍMBOLO OU 1 COR');
      return;
    } else {

        if(regra !== parseFloat(data.regra) || selo !== parseFloat(data.selo)){
          handleChangeDia();
        }

    }
  }

  return (
      <Content>
        <fieldset>        
          <legend>Escolha o Símbolo</legend>
          <div className="grid3">
              <button className={`${regra === 1 && 'checked'}`} onClick={() => setRegra(1)}><Simbol><div className={"regra1"}></div></Simbol></button>
              <button className={`${regra === 2 && 'checked'}`} onClick={() => setRegra(2)}><Simbol><div className={"regra2"}></div></Simbol></button>
              <button className={`${regra === 3 && 'checked'}`} onClick={() => setRegra(3)}><Simbol><div className={"regra3"}></div></Simbol></button>
              <button className={`${regra === 4 && 'checked'}`} onClick={() => setRegra(4)}><Simbol><div className={"regra4"}></div></Simbol></button>
              <button className={`${regra === 5 && 'checked'}`} onClick={() => setRegra(5)}><Simbol><div className={"regra5"}></div></Simbol></button>
              <button className={`${regra === 6 && 'checked'}`} onClick={() => setRegra(6)}><Simbol><div className={"regra6"}></div></Simbol></button>
          </div>
          <div className="grid3to4">
              <button className={`${regra === 7 && 'checked'}`} onClick={() => setRegra(7)}><Simbol><div className={"regra7"}></div></Simbol></button>
              <button className={`${regra === 8 && 'checked'}`} onClick={() => setRegra(8)}><Simbol><div className={"regra8"}></div></Simbol></button>
              <button className={`${regra === 9 && 'checked'}`} onClick={() => setRegra(9)}><Simbol><div className={"regra9"}></div></Simbol></button>
              <button className={`${regra === 0 && 'checked'}`} onClick={() => setRegra(0)}><div className='semDefinicao'></div></button>
          </div>
        </fieldset>
        <fieldset>
          <legend>Escolha a cor</legend>
          <div className="grid5auto">
              <button className={`${selo === 1 && 'checked'}`} onClick={() => setSelo(1)}><Selo><div className={"regra1"}></div></Selo></button>
              <button className={`${selo === 2 && 'checked'}`} onClick={() => setSelo(2)}><Selo><div className={"regra2"}></div></Selo></button>
              <button className={`${selo === 3 && 'checked'}`} onClick={() => setSelo(3)}><Selo><div className={"regra3"}></div></Selo></button>
              <button className={`${selo === 4 && 'checked'}`} onClick={() => setSelo(4)}><Selo><div className={"regra4"}></div></Selo></button>
              <button className={`${(selo === null) || (selo === 0) ? 'checked' : 'false'}`} onClick={() => setSelo(0)}><div className='semDefinicao'></div></button>
          </div>
        </fieldset> 
        <div className="flex">
          <small>Escolha pelo menos<br/>um símbolo ou uma cor</small>
          <button onClick={handleChangeBoth} className="add">ATUALIZAR</button>
        </div>
      </Content>
  );
}

export const EditRegraDia: React.FC<iDataForms> = ({ data, setShowmodal, setUpdateciclo }) => {
 
  const { user } = useAuth();
  const [regradia, setRegraDia] = useState(parseFloat(data.regradia));

  async function handleChangeDia(){     
    const send = {
      "id_mob": parseFloat(data.id_mob),
      "id_user": parseInt(data.id_user),
      "dia" : data.dia,
      "sensacao": parseInt(data.sensacao),
      "obssensacao": data.obssensacao,
      "iduseredit": parseInt(user.iduser),
      "inifimciclo": data.inifimciclo,
      "numciclo": parseFloat(data.numciclo),
      "regra": parseFloat(data.regra),
      "fertilidade": parseFloat(data.fertilidade),
      "selo": parseFloat(data.selo),
      "relacao": parseFloat(data.relacao),
      "regradia": regradia  
    }
    console.log(send)
    try {
      await api.post('/ciclos/updateDia.php', send);
      toast.success('ANOTAÇÃO ATUALIZADA COM SUCESSO');
      setUpdateciclo(true);
      setShowmodal(false);
    } catch (err: any) {
      const resp = err.response.statusText ? err.response.statusText : 'ERRO AO TENTAR ATUALIZAR';
      toast.error(resp);
    }
  }



  return (
      <Content>        
        <div className="grid4auto noPaddingButton">
            <button className={`${regradia === 1 && 'checked'}`} onClick={() => setRegraDia(1)}><RegraDia><div className={"regra1"}></div></RegraDia></button>
            <button className={`${regradia === 2 && 'checked'}`} onClick={() => setRegraDia(2)}><RegraDia><div className={"regra2"}></div></RegraDia></button>
            <button className={`${regradia === 3 && 'checked'}`} onClick={() => setRegraDia(3)}><RegraDia><div className={"regra3"}></div></RegraDia></button>
            <button className={`${regradia === 4 && 'checked'}`} onClick={() => setRegraDia(4)}><RegraDia><div className={"regra4"}></div></RegraDia></button>
        </div>

        {regradia === 1 && 
        <fieldset style={{padding: '8px 10px', marginBottom: '0px'}}>
          <strong>REGRA 1:</strong><br/>
          Evitar relação sexual nos dias de forte sangramento durante a menstruação.
        </fieldset>
        }

        {regradia === 2 && 
        <fieldset style={{padding: '8px 10px', marginBottom: '0px'}}>
          <strong>REGRA 2:</strong><br/>
          Noites alternadas estão disponíveis para relação sexual, quando estes dias foram reconhecidos como inférteis - Padrão Básico de Infertilidade (PBI).
        </fieldset>
        }

        {regradia === 3 && 
        <fieldset style={{padding: '8px 10px', marginBottom: '0px'}}>
          <strong>REGRA 3:</strong><br/>
          Evitar relação sexual em qualquer dia de fluxo ou sangramento que interrompa o PBI. Se não evoluir até o Ápice e retornar ao PBI, espere 3 dias antes de reiniciar as relações sexuais.  Continuar aplicando a Regra 2.
        </fieldset>
        }

        {regradia === 4 && 
        <fieldset style={{padding: '8px 10px', marginBottom: '0px'}}>
          <strong>REGRA DO ÁPICE:</strong><br/>
          A partir da manhã do quarto dia após o Ápice até o final do ciclo, as relações sexuais estão liberadas todos os dias a qualquer hora.
        </fieldset>
        }

        <div className="flex">
          <small>Escolha a regra<br/>para este dia</small>
          <button onClick={handleChangeDia} className="add">Atualizar</button>
        </div>
      </Content>
  );
}
